import { queryOptions, skipToken, useMutation } from "@tanstack/react-query";
import api from "../api/api";
import type {
  GetHotelAvailabilityTokenOutputData,
  GetHotelAvailabilityTokenOutputDto,
} from "../types/codegen";

interface HotelRoomAvailabilityParams {
  offerId: string;
  packageToken: string;
  roomTokens: string[];
  hotelId: string;
  searchResultKey: string;
  searchResultToken: string;
}

export const hotelRoomAvailabilityQueryOptions = (
  params: HotelRoomAvailabilityParams | null,
) => {
  return queryOptions({
    queryKey: ["hotel-availability", params] as const,
    queryFn: params
      ? ({ signal }) =>
          api.post<GetHotelAvailabilityTokenOutputDto>(
            `/hotels/${params.offerId}/availability`,
            params,
            { signal },
          )
      : skipToken,
    select: (data) => data.data.data,
    enabled: !!params,
  });
};

export type UseHotelRoomAvailabilityMutationParams = {
  onSuccess: (data: GetHotelAvailabilityTokenOutputData) => void;
  onError?: (error: Error) => void;
};

export const useHotelRoomAvailabilityMutation = ({
  onSuccess,
}: UseHotelRoomAvailabilityMutationParams) =>
  useMutation({
    mutationFn: (params: HotelRoomAvailabilityParams) =>
      api.post<GetHotelAvailabilityTokenOutputDto>(
        `/hotels/${params.offerId}/availability`,
        params,
      ),
    onSuccess: (data) => onSuccess(data.data.data),
  });
